import React from 'react';
import {Dialog, List} from 'material-ui';
import {DialogTitle} from 'material-ui';
import {Button} from 'material-ui';
import {clearWorkout} from '../utils/workoutStore';
import {DialogContent} from 'material-ui';
import {DialogContentText} from 'material-ui';

function ConfirmLeaveDialog({
	isOpen,
	onClose,
	t,
	goBack,
	onContinueLaterSelect,
}) {
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
		>
			<DialogTitle id='alert-dialog-title'>
				{t('common:appName')}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id='alert-dialog-description'>
					{t('workout:reallyQuit')}
				</DialogContentText>
			</DialogContent>

			<List>
				<Button
					fullWidth={true}
					size='large'
					onClick={() => {
						onClose();
					}}
					color='primary'
				>
					{t('workout:continue')}
				</Button>
				<Button
					fullWidth={true}
					size='large'
					onClick={() => {
						onContinueLaterSelect();
						onClose();
						goBack();
					}}
					color='primary'
				>
					{t('workout:continueLater')}
				</Button>
				<div style={{paddingTop: 30}}>
					<Button
						fullWidth={true}
						size='large'
						onClick={() => {
							clearWorkout();
							onClose();
							goBack();
						}}
						color='primary'
						autoFocus
					>
						{t('workout:discard')}
					</Button>
				</div>
			</List>
		</Dialog>
	);
}
export default ConfirmLeaveDialog;



// WEBPACK FOOTER //
// ./src/workout/ConfirmLeaveDialog.js